import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";
import images from "@/utils/images";
import { makeCnaiProps } from "@/lib/helpers/clinically-ai";

export const ExpandingSelect = (props) => {
  // collapsible=false keeps the section permanently expanded (no chevron toggle) so
  // fields stay visible/interactive for the user, without relying on the display:none
  // toggle below to ever be in the "hidden" state.
  let collapsible = props.collapsible ?? true;
  let [selecting, setSelecting] = React.useState(!collapsible);

  let controls = (
    <>
      <div className={props.labelClass}>{props.label}</div>
      {collapsible && (
        <div onClick={() => setSelecting(!selecting)}>
          <img
            src={images("./common/chevron.svg")}
            style={{
              height: 15,
              transform: selecting ? "rotate(180deg)" : "rotate(0)",
              width: 15,
            }}
          />
        </div>
      )}
    </>
  );

  let answer = Object.entries(props.options)
    .filter(([_optionKey, optionValue]) => optionValue.answer)
    .map(([_optionKey, optionValue]) => optionValue.label)
    .join(", ");

  answer = answer ? answer : "None";

  return (
    <CardSecondary
      className={"tw:p-4 " + (selecting ? "position-sticky " : "") + (props.className ?? "")}
      style={props.style}
    >
      <div className="tw:mb-2 tw:flex tw:items-center tw:justify-between">{controls}</div>

      {/* Always in DOM — CNAI needs to detect these checkboxes at all times.
          Visibility toggled via CSS so the collapsed summary still shows. */}
      <div style={selecting ? undefined : { display: "none" }}>
        {Object.entries(props.options)
          .sort((a, b) => a[1].order - b[1].order)
          .map(([optionKey, optionValue]) => (
            <div key={`${optionValue.label}${optionValue.order}`}>
              <label className="tw:flex! tw:items-baseline tw:gap-2">
                <input
                  checked={optionValue.answer ? optionValue.answer : null}
                  className="custom-checkbox tw:mt-1"
                  disabled={props.disabled ? "disabled" : null}
                  onChange={(e) => props.onChange(e, optionKey, "answer")}
                  type="checkbox"
                  value={{ optionKey, optionValue }}
                  {...(props.cnaiField &&
                    makeCnaiProps({ ...props.cnaiField, option: optionValue.label }))}
                />
                <span>{optionValue.label}</span>
              </label>
            </div>
          ))}
      </div>

      {!selecting && <div>{answer}</div>}
    </CardSecondary>
  );
};
